import React from 'react'

import {palette} from 'styled-tools'
import styled from 'styled-components'

import {NewCheckbox} from '@festi/common/components/form'

export interface ListItem {
  label: string
  value: string
  count: number
  isRefined: boolean
  highlighted?: string
}

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const Count = styled.span`
  color: ${palette('ui50Solid')};
`

interface Props {
  items: ListItem[]
  refine: (value: string) => void
}

export default function ChoiceRefinement({items, refine}: Props) {
  return (
    <>
      {items?.map((item, index) => (
        <div key={`${index}-${item.label}`}>
          <NewCheckbox
            label={
              <Label>
                <span>{item.label}</span>
                <Count>({item.count})</Count>
              </Label>
            }
            checked={item.isRefined}
            onChange={() => refine(item.value)}
          />
        </div>
      ))}
    </>
  )
}
